import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from '../error-handler.service';
import { AnimationsService } from '../animations.service';
import { environment } from '../../../environments/environment';
import { API } from '../api';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AlunoFinanceiroService {
  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
  ) { }

  consultarPainelFinanceiro(matriculaId): Observable<any> {
    const params: HttpParams = new HttpParams().set('matriculaId', matriculaId);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.alunoFinanceiroContrato.consultarPainelFinanceiro}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter painel financeiro', []))
      );
  }

  promessaPagamento(matriculaId: number, promessaPagamento: Date): Observable<any> {
    const body = { matriculaId, promessaPagamento }; // Objeto com os dados
    const usuario = this.authService.getToken();
    return this.http.patch(`${environment.baseUrl}${API.matriculaAluno.promessaPagamento}`, body, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar data de promessa de pagamento', []))
      );
  }

  contratarPlano(data): Observable<any> {    
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.contratarPlano}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError((err) : Observable<any> => {
          this.animationsService.showProgressBar(false);
          // Console error
          // console.error(`Falha ao enviar os dados: ${err?.message}`);
          console.error(`Erro ao enviar os dados: ${err}`);
          // Stop loading bar
          // SnackBar error
          this.animationsService.showErrorSnackBar(`Falha ao enviar os dados: ${err}`);
          // Return error
          return of({ status: 'error'});
        })
      );
  }

  efetuarPagamento(data): Observable<any> {    
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.efetuarPagamento}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }


  baixaManual(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.baixaManual}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }
  enviarBoletoPorEmail(data): Observable<any> {    
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.enviarBoletoPorEmail}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }

  enviarLinkParaPagamento(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    var r = this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.GerarLinkPagamento}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
    );
    
    return r;
  }

  obterLink(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();    
    var variavel = this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.GerarLinkCobrancaPagamento}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError((err) : Observable<any> => {
          this.animationsService.showProgressBar(false);
          // Console error
          // console.error(`Falha ao enviar os dados: ${err?.message}`);
          console.error(`Erro ao enviar os dados: ${err}`);
          // Stop loading bar
          // SnackBar error
          this.animationsService.showErrorSnackBar(`Falha ao enviar os dados: ${err}`);
          // Return error
          return of({ status: 'error'});
        })
      );
   
    
    return variavel;
  }
  // gerarLinkCobrancaPagamento(data): Observable<any> {
  //   this.animationsService.showProgressBar(true);
  //   return this.http.get(`${environment.baseUrl}${API.alunoFinanceiroContrato.GerarLinkCobrancaPagamento}`, data)
  //     .pipe(
  //       tap(() => this.animationsService.showProgressBar(false)),
  //       catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
  //     );
  // }

  enviarBoletoPorEmailOuRecalcular(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.enviarBoletoPorEmailOuRecalcular}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
    .pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError(this.errorHandlerService.errorHandlerAnexo('Falha ao realizar download', []))
    )
  }

  gerarBoletoResidual(data): Observable<any> {    
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.gerarBoletoResidual}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
    .pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
    )
  }

  consultarEmail(pagamentoId): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('pagamentoId', pagamentoId);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.alunoFinanceiroContrato.consultarEmail}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
    .pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError(this.errorHandlerService.errorHandlerAnexo('Falha ao consultar e-mail', []))
    )
  }

  buscarDetalhePagamento(pagamentoId): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('pagamentoId', pagamentoId);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.alunoFinanceiroContrato.buscarDetalhePagamento}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
    .pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError(this.errorHandlerService.errorHandlerAnexo('Falha ao consultar detalhe do pagamento', []))
    )
  }

  efetuarPagamentoCartaoCredito(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.alunoFinanceiroContrato.efetuarPagamentoCartaoCredito}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao realizar pagamento', []))
      );
  }

  criarAcordo(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.acordoCobranca.criar}`, data, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + usuario?.token)
    }).pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError((err): Observable<any> => {
        this.animationsService.showProgressBar(false);
        console.error('Erro ao criar acordo:', err);
        this.animationsService.showErrorSnackBar(
          `Falha ao criar acordo: ${err?.error?.mensagem || err?.message || 'Erro desconhecido'}`
        );
        return of({ isSuccess: false, mensagem: err?.error?.mensagem || 'Erro ao criar acordo' });
      })
    );
  }

  editarAcordo(acordoId: number, data: any): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.put(`${environment.baseUrl}${API.acordoCobranca.consultar}/${acordoId}/Editar`, data, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + usuario?.token)
    }).pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError((err): Observable<any> => {
        this.animationsService.showProgressBar(false);
        this.animationsService.showErrorSnackBar(
          `Falha ao editar acordo: ${err?.error?.mensagem || err?.message || 'Erro desconhecido'}`
        );
        return of({ isSuccess: false, mensagem: err?.error?.mensagem || 'Erro ao editar acordo' });
      })
    );
  }

  enviarEmailAcordo(acordoId: number, email: string): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.acordoCobranca.enviarEmail}/${acordoId}/EnviarEmail`,
      { email },
      { headers: new HttpHeaders().set('Authorization', 'Bearer ' + usuario?.token) }
    ).pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError((err): Observable<any> => {
        this.animationsService.showProgressBar(false);
        this.animationsService.showErrorSnackBar(
          err?.error?.mensagem || 'Falha ao enviar email do acordo'
        );
        return of({ isSuccess: false, mensagem: err?.error?.mensagem || 'Erro ao enviar email' });
      })
    );
  }

  consultarAcordo(acordoId: number): Observable<any> {
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.acordoCobranca.consultar}/${acordoId}`, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + usuario?.token)
    }).pipe(
      catchError(this.errorHandlerService.errorHandler('Falha ao consultar acordo', null))
    );
  }

  renovarAcordo(acordoId: number): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.acordoCobranca.renovar}/${acordoId}/Renovar`, {}, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + usuario?.token)
    }).pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError((err): Observable<any> => {
        this.animationsService.showProgressBar(false);
        this.animationsService.showErrorSnackBar(
          err?.error?.mensagem || 'Falha ao renovar acordo'
        );
        return of({ isSuccess: false, mensagem: err?.error?.mensagem || 'Erro ao renovar acordo' });
      })
    );
  }

  cancelarAcordo(acordoId: number, motivo: string): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.acordoCobranca.cancelar}/${acordoId}/Cancelar`,
      { motivo, usuarioCanceladorId: usuario?.user?.id },
      { headers: new HttpHeaders().set('Authorization', 'Bearer ' + usuario?.token) }
    ).pipe(
      tap(() => this.animationsService.showProgressBar(false)),
      catchError((err): Observable<any> => {
        this.animationsService.showProgressBar(false);
        this.animationsService.showErrorSnackBar('Falha ao cancelar acordo');
        return of({ isSuccess: false });
      })
    );
  }

  ConsultarCobranca(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.cobranca.consultarCobranca}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao realizar pagamento', []))
      );
  }
}
